export const schoolCalendar = {
  title: "Calendario Escolar",
  subtitle: "Curso 2026/2027 - Fechas importantes y eventos del año académico",
  courseDate: {
    title: "Inicio y fin de curso",
    start: "Inicio de curso",
    startDate: "9 de septiembre de 2026",
    end: "Fin de curso",
    endDate: "21 de junio de 2027"
  },
  holidays: {
    title: "Vacaciones",
    items: [
      {
        name: "Navidad",
        date: "del 22 de diciembre de 2026 al 7 de enero de 2027 (ambos inclusive)"
      },
      {
        name: "Entroido (Carnaval)",
        date: "8, 9 y 10 de febrero de 2027 (ambos inclusive)"
      },
      {
        name: "Semana Santa",
        date: "del 22 al 29 de marzo de 2027 (ambos inclusive)"
      }
    ]
  },
  publicHolidays: {
    title: "Festivos",
    items: [
      {
        name: "Fiesta Nacional",
        date: "12 de octubre de 2026"
      },
      {
        name: "Inmaculada Concepción",
        date: "8 de diciembre de 2026"
      },
      {
        name: "San Xosé (Día del Padre)",
        date: "19 de marzo de 2027"
      },
      {
        name: "Día del Trabajador",
        date: "1 de mayo de 2027"
      },
      {
        name: "Letras Galegas",
        date: "17 de mayo de 2027"
      }
    ]
  },
  nonSchoolDays: {
    title: "Días no lectivos (Xunta)",
    items: [
      {
        name: "Día do Ensino",
        date: "7 de diciembre de 2026"
      }
    ]
  },
  familyCelebrations: {
    title: "Celebraciones en Gándara (con familias)",
    items: [
      {
        name: "Samaín-Magosto",
        date: "30 de octubre de 2026"
      },
      {
        name: "Solsticio de invierno",
        date: "21 de diciembre de 2026"
      },
      {
        name: "Entroido",
        date: "5 de febrero de 2027"
      },
      {
        name: "Equinoccio de primavera",
        date: "18 de marzo de 2027"
      },
      {
        name: "Fiesta fin de curso",
        date: "21 de junio de 2027"
      }
    ]
  },
  familyMeetings: {
    title: "Reuniones con familias",
    items: [
      {
        name: "Reunión de inicio de curso",
        date: "7 de septiembre de 2026"
      },
      {
        name: "Reunión del 2º trimestre",
        date: "14 de diciembre de 2026"
      },
      {
        name: "Reunión de cierre de curso",
        date: "14 de junio de 2027"
      }
    ]
  }
};
